/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Why_Private_TitleInputs */

const en_wc_why_private_title = /** @type {(inputs: Wc_Why_Private_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private by design`)
};

/**
* | output |
* | --- |
* | "Private by design" |
*
* @param {Wc_Why_Private_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_why_private_title = /** @type {((inputs?: Wc_Why_Private_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Why_Private_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_why_private_title(inputs)
});
export { wc_why_private_title as "wc.why.private.title" }